module.exports = __webpack_public_path__ + "cabe42500bd1c98aac94bf0b540c63b6.png";